// Number counter that eases from 0 → value on mount and on value-change.
// Uses framer-motion's animate() so it stays smooth 60fps.
// Renders whatever the value is when non-numeric (e.g. "24u", "–").
import { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";

function coerce(v) {
  if (v === null || v === undefined || v === "") return { n: null, suffix: "" };
  if (typeof v === "number") return { n: v, suffix: "" };
  // string like "24u" or "8.5u" or "12" — parse leading number, keep suffix
  const s = String(v);
  const m = s.match(/^(-?\d+(?:\.\d+)?)(.*)$/);
  if (!m) return { n: null, suffix: "" };
  return { n: parseFloat(m[1]), suffix: m[2] };
}

export default function AnimatedNumber({ value, duration = 0.8 }) {
  const { n, suffix } = coerce(value);
  const [display, setDisplay] = useState(n === null ? value : 0);
  const prevRef = useRef(0);

  useEffect(() => {
    if (n === null) { setDisplay(value); return; }
    const from = prevRef.current || 0;
    const controls = animate(from, n, {
      duration,
      ease: [0.4, 0, 0.2, 1],
      onUpdate: (v) => {
        // Preserve one decimal only if source had one, else integer.
        const rounded = suffix.includes(".") || /\.\d/.test(String(value))
          ? Math.round(v * 10) / 10
          : Math.round(v);
        setDisplay(`${rounded}${suffix}`);
      },
    });
    prevRef.current = n;
    return () => controls.stop();
  }, [n, suffix, duration, value]);

  return <>{display ?? "–"}</>;
}
